import { default as companyzHnlaVUlFvMeta } from "/opt/atlassian/pipelines/agent/build/pages/about/company.vue?macro=true";
import { default as teammrp0ALEc80Meta } from "/opt/atlassian/pipelines/agent/build/pages/about/team.vue?macro=true";
import { default as testimonialspjzkLxOtyBMeta } from "/opt/atlassian/pipelines/agent/build/pages/about/testimonials.vue?macro=true";
import { default as basic_45componentsSdiO50jN1qMeta } from "/opt/atlassian/pipelines/agent/build/pages/basic-components.vue?macro=true";
import { default as contactggdDqdGlSrMeta } from "/opt/atlassian/pipelines/agent/build/pages/contact.vue?macro=true";
import { default as demoUeKXuwApCXMeta } from "/opt/atlassian/pipelines/agent/build/pages/demo.vue?macro=true";
import { default as analytics_45insightskG0shpxU7jMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/analytics-insights.vue?macro=true";
import { default as collaboration_45toolsEUTRhhp1qaMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/collaboration-tools.vue?macro=true";
import { default as content_45analyticsTnQOj1zokVMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/content-analytics.vue?macro=true";
import { default as content_45creationoHEK81D8tzMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/content-creation.vue?macro=true";
import { default as content_45distributionzuBeQw26CrMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/content-distribution.vue?macro=true";
import { default as content_45managementxOq8QwXednMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/content-management.vue?macro=true";
import { default as design_45components3pIqhtKgzAMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/design-components.vue?macro=true";
import { default as integration_45ecosystemwMlqgFgt8DMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/integration-ecosystem.vue?macro=true";
import { default as multi_45channel_45publishing2C5g0dStW1Meta } from "/opt/atlassian/pipelines/agent/build/pages/features/multi-channel-publishing.vue?macro=true";
import { default as seo_45optimizationuczQNuCtHuMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/seo-optimization.vue?macro=true";
import { default as team_45collaborationRuYRSJjJcGMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/team-collaboration.vue?macro=true";
import { default as workflow_45automationJyzuABJrtUMeta } from "/opt/atlassian/pipelines/agent/build/pages/features/workflow-automation.vue?macro=true";
import { default as indexOD9t3F2bSJMeta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as privacy_45policyexbUBbnK83Meta } from "/opt/atlassian/pipelines/agent/build/pages/legal/privacy-policy.vue?macro=true";
import { default as terms_45of_45service9X0hwYD1jXMeta } from "/opt/atlassian/pipelines/agent/build/pages/legal/terms-of-service.vue?macro=true";
import { default as logineaOYVOrhPDMeta } from "/opt/atlassian/pipelines/agent/build/pages/login.vue?macro=true";
import { default as pricingevsz0GYkgYMeta } from "/opt/atlassian/pipelines/agent/build/pages/pricing.vue?macro=true";
import { default as blogz418b7AOnLMeta } from "/opt/atlassian/pipelines/agent/build/pages/resources/blog.vue?macro=true";
import { default as case_45studiesAZkhTLqsDwMeta } from "/opt/atlassian/pipelines/agent/build/pages/resources/case-studies.vue?macro=true";
import { default as communityENgo0OdOC4Meta } from "/opt/atlassian/pipelines/agent/build/pages/resources/community.vue?macro=true";
import { default as documentationKeWDBrGISnMeta } from "/opt/atlassian/pipelines/agent/build/pages/resources/documentation.vue?macro=true";
import { default as knowledge_45basedgLAVMhmqrMeta } from "/opt/atlassian/pipelines/agent/build/pages/resources/knowledge-base.vue?macro=true";
import { default as tutorials_45webinarsPbKoASNqlZMeta } from "/opt/atlassian/pipelines/agent/build/pages/resources/tutorials-webinars.vue?macro=true";
import { default as sitemapNcZXQarLrYMeta } from "/opt/atlassian/pipelines/agent/build/pages/sitemap.vue?macro=true";
import { default as use_45case_451fmttJWM87rMeta } from "/opt/atlassian/pipelines/agent/build/pages/solutions/use-case-1.vue?macro=true";
import { default as use_45case_452v8QURGlfgKMeta } from "/opt/atlassian/pipelines/agent/build/pages/solutions/use-case-2.vue?macro=true";
import { default as use_45case_453iDDGqFdjz9Meta } from "/opt/atlassian/pipelines/agent/build/pages/solutions/use-case-3.vue?macro=true";
import { default as solutionsKnft1yi4NrMeta } from "/opt/atlassian/pipelines/agent/build/pages/solutions.vue?macro=true";
export default [
  {
    name: companyzHnlaVUlFvMeta?.name ?? "about-company",
    path: companyzHnlaVUlFvMeta?.path ?? "/about/company",
    meta: companyzHnlaVUlFvMeta || {},
    alias: companyzHnlaVUlFvMeta?.alias || [],
    redirect: companyzHnlaVUlFvMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/about/company.vue").then(m => m.default || m)
  },
  {
    name: teammrp0ALEc80Meta?.name ?? "about-team",
    path: teammrp0ALEc80Meta?.path ?? "/about/team",
    meta: teammrp0ALEc80Meta || {},
    alias: teammrp0ALEc80Meta?.alias || [],
    redirect: teammrp0ALEc80Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: testimonialspjzkLxOtyBMeta?.name ?? "about-testimonials",
    path: testimonialspjzkLxOtyBMeta?.path ?? "/about/testimonials",
    meta: testimonialspjzkLxOtyBMeta || {},
    alias: testimonialspjzkLxOtyBMeta?.alias || [],
    redirect: testimonialspjzkLxOtyBMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/about/testimonials.vue").then(m => m.default || m)
  },
  {
    name: basic_45componentsSdiO50jN1qMeta?.name ?? "basic-components",
    path: basic_45componentsSdiO50jN1qMeta?.path ?? "/basic-components",
    meta: basic_45componentsSdiO50jN1qMeta || {},
    alias: basic_45componentsSdiO50jN1qMeta?.alias || [],
    redirect: basic_45componentsSdiO50jN1qMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/basic-components.vue").then(m => m.default || m)
  },
  {
    name: contactggdDqdGlSrMeta?.name ?? "contact",
    path: contactggdDqdGlSrMeta?.path ?? "/contact",
    meta: contactggdDqdGlSrMeta || {},
    alias: contactggdDqdGlSrMeta?.alias || [],
    redirect: contactggdDqdGlSrMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: demoUeKXuwApCXMeta?.name ?? "demo",
    path: demoUeKXuwApCXMeta?.path ?? "/demo",
    meta: demoUeKXuwApCXMeta || {},
    alias: demoUeKXuwApCXMeta?.alias || [],
    redirect: demoUeKXuwApCXMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/demo.vue").then(m => m.default || m)
  },
  {
    name: analytics_45insightskG0shpxU7jMeta?.name ?? "features-analytics-insights",
    path: analytics_45insightskG0shpxU7jMeta?.path ?? "/features/analytics-insights",
    meta: analytics_45insightskG0shpxU7jMeta || {},
    alias: analytics_45insightskG0shpxU7jMeta?.alias || [],
    redirect: analytics_45insightskG0shpxU7jMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/analytics-insights.vue").then(m => m.default || m)
  },
  {
    name: collaboration_45toolsEUTRhhp1qaMeta?.name ?? "features-collaboration-tools",
    path: collaboration_45toolsEUTRhhp1qaMeta?.path ?? "/features/collaboration-tools",
    meta: collaboration_45toolsEUTRhhp1qaMeta || {},
    alias: collaboration_45toolsEUTRhhp1qaMeta?.alias || [],
    redirect: collaboration_45toolsEUTRhhp1qaMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/collaboration-tools.vue").then(m => m.default || m)
  },
  {
    name: content_45analyticsTnQOj1zokVMeta?.name ?? "features-content-analytics",
    path: content_45analyticsTnQOj1zokVMeta?.path ?? "/features/content-analytics",
    meta: content_45analyticsTnQOj1zokVMeta || {},
    alias: content_45analyticsTnQOj1zokVMeta?.alias || [],
    redirect: content_45analyticsTnQOj1zokVMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/content-analytics.vue").then(m => m.default || m)
  },
  {
    name: content_45creationoHEK81D8tzMeta?.name ?? "features-content-creation",
    path: content_45creationoHEK81D8tzMeta?.path ?? "/features/content-creation",
    meta: content_45creationoHEK81D8tzMeta || {},
    alias: content_45creationoHEK81D8tzMeta?.alias || [],
    redirect: content_45creationoHEK81D8tzMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/content-creation.vue").then(m => m.default || m)
  },
  {
    name: content_45distributionzuBeQw26CrMeta?.name ?? "features-content-distribution",
    path: content_45distributionzuBeQw26CrMeta?.path ?? "/features/content-distribution",
    meta: content_45distributionzuBeQw26CrMeta || {},
    alias: content_45distributionzuBeQw26CrMeta?.alias || [],
    redirect: content_45distributionzuBeQw26CrMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/content-distribution.vue").then(m => m.default || m)
  },
  {
    name: content_45managementxOq8QwXednMeta?.name ?? "features-content-management",
    path: content_45managementxOq8QwXednMeta?.path ?? "/features/content-management",
    meta: content_45managementxOq8QwXednMeta || {},
    alias: content_45managementxOq8QwXednMeta?.alias || [],
    redirect: content_45managementxOq8QwXednMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/content-management.vue").then(m => m.default || m)
  },
  {
    name: design_45components3pIqhtKgzAMeta?.name ?? "features-design-components",
    path: design_45components3pIqhtKgzAMeta?.path ?? "/features/design-components",
    meta: design_45components3pIqhtKgzAMeta || {},
    alias: design_45components3pIqhtKgzAMeta?.alias || [],
    redirect: design_45components3pIqhtKgzAMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/design-components.vue").then(m => m.default || m)
  },
  {
    name: integration_45ecosystemwMlqgFgt8DMeta?.name ?? "features-integration-ecosystem",
    path: integration_45ecosystemwMlqgFgt8DMeta?.path ?? "/features/integration-ecosystem",
    meta: integration_45ecosystemwMlqgFgt8DMeta || {},
    alias: integration_45ecosystemwMlqgFgt8DMeta?.alias || [],
    redirect: integration_45ecosystemwMlqgFgt8DMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/integration-ecosystem.vue").then(m => m.default || m)
  },
  {
    name: multi_45channel_45publishing2C5g0dStW1Meta?.name ?? "features-multi-channel-publishing",
    path: multi_45channel_45publishing2C5g0dStW1Meta?.path ?? "/features/multi-channel-publishing",
    meta: multi_45channel_45publishing2C5g0dStW1Meta || {},
    alias: multi_45channel_45publishing2C5g0dStW1Meta?.alias || [],
    redirect: multi_45channel_45publishing2C5g0dStW1Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/multi-channel-publishing.vue").then(m => m.default || m)
  },
  {
    name: seo_45optimizationuczQNuCtHuMeta?.name ?? "features-seo-optimization",
    path: seo_45optimizationuczQNuCtHuMeta?.path ?? "/features/seo-optimization",
    meta: seo_45optimizationuczQNuCtHuMeta || {},
    alias: seo_45optimizationuczQNuCtHuMeta?.alias || [],
    redirect: seo_45optimizationuczQNuCtHuMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/seo-optimization.vue").then(m => m.default || m)
  },
  {
    name: team_45collaborationRuYRSJjJcGMeta?.name ?? "features-team-collaboration",
    path: team_45collaborationRuYRSJjJcGMeta?.path ?? "/features/team-collaboration",
    meta: team_45collaborationRuYRSJjJcGMeta || {},
    alias: team_45collaborationRuYRSJjJcGMeta?.alias || [],
    redirect: team_45collaborationRuYRSJjJcGMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/team-collaboration.vue").then(m => m.default || m)
  },
  {
    name: workflow_45automationJyzuABJrtUMeta?.name ?? "features-workflow-automation",
    path: workflow_45automationJyzuABJrtUMeta?.path ?? "/features/workflow-automation",
    meta: workflow_45automationJyzuABJrtUMeta || {},
    alias: workflow_45automationJyzuABJrtUMeta?.alias || [],
    redirect: workflow_45automationJyzuABJrtUMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/features/workflow-automation.vue").then(m => m.default || m)
  },
  {
    name: indexOD9t3F2bSJMeta?.name ?? "index",
    path: indexOD9t3F2bSJMeta?.path ?? "/",
    meta: indexOD9t3F2bSJMeta || {},
    alias: indexOD9t3F2bSJMeta?.alias || [],
    redirect: indexOD9t3F2bSJMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyexbUBbnK83Meta?.name ?? "legal-privacy-policy",
    path: privacy_45policyexbUBbnK83Meta?.path ?? "/legal/privacy-policy",
    meta: privacy_45policyexbUBbnK83Meta || {},
    alias: privacy_45policyexbUBbnK83Meta?.alias || [],
    redirect: privacy_45policyexbUBbnK83Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/legal/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45service9X0hwYD1jXMeta?.name ?? "legal-terms-of-service",
    path: terms_45of_45service9X0hwYD1jXMeta?.path ?? "/legal/terms-of-service",
    meta: terms_45of_45service9X0hwYD1jXMeta || {},
    alias: terms_45of_45service9X0hwYD1jXMeta?.alias || [],
    redirect: terms_45of_45service9X0hwYD1jXMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/legal/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: logineaOYVOrhPDMeta?.name ?? "login",
    path: logineaOYVOrhPDMeta?.path ?? "/login",
    meta: logineaOYVOrhPDMeta || {},
    alias: logineaOYVOrhPDMeta?.alias || [],
    redirect: logineaOYVOrhPDMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue").then(m => m.default || m)
  },
  {
    name: pricingevsz0GYkgYMeta?.name ?? "pricing",
    path: pricingevsz0GYkgYMeta?.path ?? "/pricing",
    meta: pricingevsz0GYkgYMeta || {},
    alias: pricingevsz0GYkgYMeta?.alias || [],
    redirect: pricingevsz0GYkgYMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: blogz418b7AOnLMeta?.name ?? "resources-blog",
    path: blogz418b7AOnLMeta?.path ?? "/resources/blog",
    meta: blogz418b7AOnLMeta || {},
    alias: blogz418b7AOnLMeta?.alias || [],
    redirect: blogz418b7AOnLMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resources/blog.vue").then(m => m.default || m)
  },
  {
    name: case_45studiesAZkhTLqsDwMeta?.name ?? "resources-case-studies",
    path: case_45studiesAZkhTLqsDwMeta?.path ?? "/resources/case-studies",
    meta: case_45studiesAZkhTLqsDwMeta || {},
    alias: case_45studiesAZkhTLqsDwMeta?.alias || [],
    redirect: case_45studiesAZkhTLqsDwMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resources/case-studies.vue").then(m => m.default || m)
  },
  {
    name: communityENgo0OdOC4Meta?.name ?? "resources-community",
    path: communityENgo0OdOC4Meta?.path ?? "/resources/community",
    meta: communityENgo0OdOC4Meta || {},
    alias: communityENgo0OdOC4Meta?.alias || [],
    redirect: communityENgo0OdOC4Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resources/community.vue").then(m => m.default || m)
  },
  {
    name: documentationKeWDBrGISnMeta?.name ?? "resources-documentation",
    path: documentationKeWDBrGISnMeta?.path ?? "/resources/documentation",
    meta: documentationKeWDBrGISnMeta || {},
    alias: documentationKeWDBrGISnMeta?.alias || [],
    redirect: documentationKeWDBrGISnMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resources/documentation.vue").then(m => m.default || m)
  },
  {
    name: knowledge_45basedgLAVMhmqrMeta?.name ?? "resources-knowledge-base",
    path: knowledge_45basedgLAVMhmqrMeta?.path ?? "/resources/knowledge-base",
    meta: knowledge_45basedgLAVMhmqrMeta || {},
    alias: knowledge_45basedgLAVMhmqrMeta?.alias || [],
    redirect: knowledge_45basedgLAVMhmqrMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resources/knowledge-base.vue").then(m => m.default || m)
  },
  {
    name: tutorials_45webinarsPbKoASNqlZMeta?.name ?? "resources-tutorials-webinars",
    path: tutorials_45webinarsPbKoASNqlZMeta?.path ?? "/resources/tutorials-webinars",
    meta: tutorials_45webinarsPbKoASNqlZMeta || {},
    alias: tutorials_45webinarsPbKoASNqlZMeta?.alias || [],
    redirect: tutorials_45webinarsPbKoASNqlZMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resources/tutorials-webinars.vue").then(m => m.default || m)
  },
  {
    name: sitemapNcZXQarLrYMeta?.name ?? "sitemap",
    path: sitemapNcZXQarLrYMeta?.path ?? "/sitemap",
    meta: sitemapNcZXQarLrYMeta || {},
    alias: sitemapNcZXQarLrYMeta?.alias || [],
    redirect: sitemapNcZXQarLrYMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/sitemap.vue").then(m => m.default || m)
  },
  {
    name: solutionsKnft1yi4NrMeta?.name ?? "solutions",
    path: solutionsKnft1yi4NrMeta?.path ?? "/solutions",
    children: [
  {
    name: use_45case_451fmttJWM87rMeta?.name ?? "solutions-use-case-1",
    path: use_45case_451fmttJWM87rMeta?.path ?? "use-case-1",
    meta: use_45case_451fmttJWM87rMeta || {},
    alias: use_45case_451fmttJWM87rMeta?.alias || [],
    redirect: use_45case_451fmttJWM87rMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/solutions/use-case-1.vue").then(m => m.default || m)
  },
  {
    name: use_45case_452v8QURGlfgKMeta?.name ?? "solutions-use-case-2",
    path: use_45case_452v8QURGlfgKMeta?.path ?? "use-case-2",
    meta: use_45case_452v8QURGlfgKMeta || {},
    alias: use_45case_452v8QURGlfgKMeta?.alias || [],
    redirect: use_45case_452v8QURGlfgKMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/solutions/use-case-2.vue").then(m => m.default || m)
  },
  {
    name: use_45case_453iDDGqFdjz9Meta?.name ?? "solutions-use-case-3",
    path: use_45case_453iDDGqFdjz9Meta?.path ?? "use-case-3",
    meta: use_45case_453iDDGqFdjz9Meta || {},
    alias: use_45case_453iDDGqFdjz9Meta?.alias || [],
    redirect: use_45case_453iDDGqFdjz9Meta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/solutions/use-case-3.vue").then(m => m.default || m)
  }
],
    meta: solutionsKnft1yi4NrMeta || {},
    alias: solutionsKnft1yi4NrMeta?.alias || [],
    redirect: solutionsKnft1yi4NrMeta?.redirect || undefined,
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/solutions.vue").then(m => m.default || m)
  }
]